<template>
  <user-center-slot>
    <user-center-container-slot>
        <!-- 左侧菜单栏 -->
        <user-center-menu />
        <!-- 右侧内容 -->
        <user-center-content-slot>
          <user-center-content-title title="消息中心" />
          <div class="user-center__msg-row">
            <div>
              <i class="iconfont icon-xiaoxi user-center__msg-icon--default"></i>
            </div>
            <div class="user-center__msg-number"> 您有<span class="user-center__msg-number-txt" id="msgNum"></span>条新消息</div>
          </div>

          <div class="user-center__msg-operation">
            <a href="javascript:void(0);" @click="updateMsgCenterState" class="user-center__msg-operation-button">全部标记已读</a>
            <a href="javascript:void(0);" @click="delHandle" class="user-center__msg-operation-button">删除选中消息</a>
          </div>

          <div class="user-center__msg-list">
            <xui-table :data="latestData" @selection-change="handleSelectionChange" :stripe="false" :show-header="true" style="width: 100%;">
              <xui-table-column type="selection" align="center" width="33"> </xui-table-column>

              <xui-table-column min-width="96" prop="title" label="消息主题" show-overflow-tooltip align="left">
                <template slot-scope="scope">
                  <a href="javascript:void(0);" @click="showDetail(scope.row)" class="user-center__msg-list-link">{{ scope.row.title }}</a>
                </template>
              </xui-table-column>

              <xui-table-column prop="status" class="is-top" label="消息类型">
                <template slot-scope="scope">
                  {{ scope.row.status ? statusOption[scope.row.status].label : statusOption[scope.row.status].label }}
                </template>
              </xui-table-column>

              <xui-table-column prop="creationDate" class="is-top" label="发送时间"> </xui-table-column>
            </xui-table>
          </div>

          <div class="user-center__msg-pager">
            <xui-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="5" layout="total, pager, jumper" :total="total"> </xui-pagination>
          </div>
        </user-center-content-slot>
    </user-center-container-slot>
    <xui-dialog title="" :close-on-click-modal="false" showcenter :visible.sync="delWarnning" width="30%">
      <p class="dialog-content">
        <span>
          <img src="../../../images/message.png" class="img-status" />
        </span>
      </p>
      <p class="dialog-content">
        <span> 请选择需要删除的消息！ </span>
      </p>
    </xui-dialog>
    <!-- 登录提示弹框 -->
    <xui-dialog v-if="isNotLogin && isEffect" title="失效提醒" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isNotLogin" @close="handleClose" width="30%">
      <span>您的账号已经失效，请联系管理员</span>
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="handleClose">返回首页</xui-button>
      </span>
    </xui-dialog>
    <xui-dialog v-else title="登录提醒" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isNotLogin" @close="handleClose" width="30%">
      <span>系统检测到您未登录或登录失效，请先登录</span>
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="login">荣耀账号登录</xui-button>
      </span>
    </xui-dialog>

    <!-- 消息详情 -->
    <xui-dialog :close-on-click-modal="false" showcenter :visible.sync="dialogVisible" width="600px" @close="handleCloseByMsg">
      <div class="msg-title">
        {{ msgData.title }}
      </div>
      <div class="msg-html">
        <div class="addresseeName">{{ msgData.userName }}</div>
        <div v-html="msgData.concent"></div>
      </div>
      <div class="msg-time">
        {{ msgData.creationDate }}
      </div>
    </xui-dialog>
  </user-center-slot>
</template>
<script>
import UserCenterMenu from '../../../components/pages/UserCenterMenu'
import UserCenterContainerSlot from '../../../components/pages/UserCenterContainerSlot'
import UserCenterSlot from '../../../components/pages/UserCenterSlot'
import UserCenterContentSlot from '../../../components/pages/UserCenterContentSlot'
import UserCenterContentTitle from '../../../components/pages/UserCenterContentTitle'
import router from '../../../router/index.js';
import { v4 } from 'uuid';
import { mapState } from 'vuex';
import store from '../../../store/index'

export default {
  name: 'usercenterSiteMsg',
  components: {
    UserCenterMenu,
    UserCenterSlot,
    UserCenterContainerSlot,
    UserCenterContentSlot,
    UserCenterContentTitle
  },
  data() {
    return {
      isEffect: false,
      isNotLogin: false,
      currentPage: 1,
      total: 1,
      pageSize: 5,
      statusOption: [
        {
          key: 0,
          label: '未读',
          value: 0
        },
        {
          key: 1,
          label: '已读',
          value: 1
        },
        {
          key: 2,
          label: '已删除',
          value: 2
        }
      ],
      latestData: [],
      multipleSelection: [],
      delWarnning: false,
      dialogVisible: false,
      msgData: {}
    };
  },
  computed: {
    ...mapState(['unReadBbsCount', 'unReadMsgListCount'])
  },
  mounted() {
    // 登陆状态时，获取CSRF
    this.getCSRF();
    this.getUserInfo();
 
  },
  methods: {
    login: function() {
      this.loginHandle();
    },
    // 点击登录
    loginHandle: function() {
      let client_id = '',
        login_channel = '',
        req_client_type = '',
        redirect_uri = '',
        scope = '';
      for (let metas = document.getElementsByTagName('meta'), i = 0; i < metas.length; ++i) {
        switch (metas[i].name) {
          case 'client_id':
            client_id = metas[i].content;
            break;
          case 'login_channel':
            login_channel = metas[i].content;
            break;
          case 'req_client_type':
            req_client_type = metas[i].content;
            break;
          case 'redirect_uri':
            redirect_uri = metas[i].content;
            break;
          case 'scope':
            scope = metas[i].content;
            break;
          default:
            break;
        }
      }
      let stautusData = v4();
      let authURL = window.location.host === 'security.honor.com' ? 'https://hnoauth-login-drcn.cloud.honor.com/oauth2/v3/authorize?' : 'https://hnoauth-login-test-drcn.cloud.honor.com/oauth2/v3/authorize?';
      let redirectUrl =
        authURL +
        'response_type=code&access_type=offline&state=' +
        stautusData +
        '&client_id=' +
        client_id +
        '&login_channel=' +
        login_channel +
        '&req_client_type=' +
        req_client_type +
        '&redirect_uri=' +
        redirect_uri +
        '&scope=' +
        scope;

      window.location.href = redirectUrl;
    },
    handleClose: function() {
      this.$router.push({ path: '/' });
    },
    handleCloseByMsg: function() {
      window.location.reload();
    },
    getCSRF: function() {
      const that = this;
      const options = {
        withCredentials: true,
        headers: {
          'x-csrf-token': null
        }
      };

      let s = new Promise((resolve, reject) => {
        this.$http
          .get('common/hsrc/vul/common/services/jalor/web/support/workspace/current', { headers: { 'x-celon-admin': true, 'x-sub-app-id': 'hsrc_vul' } })
          .then(res => {
            if (res['headers']['x-csrf-token']) {
              window.sessionStorage.setItem('x-csrf-token', res['headers']['x-csrf-token']);
            } else {
              this.isNotLogin = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    getMsgCentreInfo: function() {
      let s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/sitemsg/list?pageNo=' + this.currentPage + '&pageSize=' + this.pageSize, {})
          .then(res => {
            console.log(res); //获取数据
            // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
            if (res.data && res.status === 200) {
              global.this_siteMsg = this;
              this.latestData = res.data.result;
              this.total = res.data.pageVO.totalRows;
            } else {
              global.this_siteMsg.success = false;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });

      let g = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/sitemsg/unreadCount', [])
          .then(res => {
            console.log(res); //获取数据
            // 可通过resolve发送给后端一些参数:resolve(res.data.xxx);
            if (res.data.data && res.status === 200) {
              document.getElementById('msgNum').innerHTML = res.data.data;
            } else {
              document.getElementById('msgNum').innerHTML = 0;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    updateMsgCenterState() {
      // 修改用户下所有消息为已读，接口不传参即为修改全部为已读
      let s = new Promise((resolve, reject) => {
        this.$http
          .post('vul/hsrc/vul/report/services/sitemsg/updatestatus', [], { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            console.log(res);
            if (res.data.status === 200) {
              global.this_siteMsg.getMsgCentreInfo();
              window.location.reload();
            } else {
              global.this_siteMsg.success = false;
            }
            setTimeout(() => {
              global.this_siteMsg.delWarnning = false;
            }, 2000);
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    updateMsgCenterStateByOne(msgId) {
      var listId = new Array(msgId);
      // 修改用户下所有消息为已读，接口不传参即为修改全部为已读
      let s = new Promise((resolve, reject) => {
        this.$http
          .post('vul/hsrc/vul/report/services/sitemsg/updatestatus', listId, { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            console.log(res);
            if (res.data.status === 200) {
              global.this_siteMsg.getMsgCentreInfo();
            } else {
              global.this_siteMsg.success = false;
            }
            setTimeout(() => {
              global.this_siteMsg.delWarnning = false;
            }, 2000);
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    delHandle() {
      var msgIdList = new Array();
      if (null == this.multipleSelection || this.multipleSelection.length === 0) {
        this.delWarnning = true;
      } else {
        console.log('选中内容：', this.multipleSelection);
        var result = this.multipleSelection;
        for (var i = 0; i < result.length; i++) {
          msgIdList.push(result[i].msgId);
        }
      }
      if (msgIdList.length === 0) {
        return;
      }
      // 调用删除的接口
      let s = new Promise((resolve, reject) => {
        this.$http
          .post('vul/hsrc/vul/report/services/sitemsg/delete', msgIdList, { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            console.log(res);
            if (res.data && res.data.status === 200) {
              global.this_siteMsg.getMsgCentreInfo();
              window.location.reload();
            } else {
              global.this_siteMsg.success = false;
            }
            setTimeout(() => {
              global.this_siteMsg.delWarnning = false;
            }, 2000);
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    selectHandle: (index, indexPath) => {
      if (index === '1') {
        router.push({ path: '/usercenter/info' });
      }
      if (index === '2') {
        router.push({ path: '/usercenter/idinfo' });
      }
      if (index === '3') {
        router.push({ path: '/usercenter/report' });
      }
      if (index === '4') {
        router.push({ path: '/usercenter/sitemsg' });
      }
      if (index === '5') {
        router.push({ path: '/usercenter/teamMenu' });
      }
    },
    handleRow(row, event, column) {
      this.$router.push({ path: '/usercenter/report/detail', query: { code: row.code } });
    },
    handleCurrentChange(val) {
      this.getMsgCentreInfo();
    },
    showDetail(data) {
      console.log(data);
      let concent = this.xssDefend(data.content);
      this.msgData.title = data.title;
      this.msgData.concent = concent.replace(/\n/g, '<br/>');
      this.msgData.creationDate = data.creationDate;
      this.dialogVisible = true;
      this.updateMsgCenterStateByOne(data.msgId);
    },
    xssDefend(str) {
      if (typeof str !== 'string') {
        return '';
      }
      let html = window.filterXSS(str, {
        whiteList: {
          table: ['width', 'border', 'align', 'valign'],
          tbody: ['align', 'valign', 'text-align'],
          td: ['width', 'rowspan', 'colspan', 'align', 'valign'],
          tfoot: ['align', 'valign'],
          th: ['width', 'rowspan', 'colspan', 'align', 'valign'],
          thead: ['align', 'valign', 'text-align'],
          tr: ['rowspan', 'align', 'valign', 'text-align'],
          tt: [],
          a: ['href'],
          abbr: ['title'],
          address: [],
          area: ['shape', 'coords', 'href', 'alt'],
          article: [],
          aside: [],
          b: [],
          bdi: ['dir'],
          bdo: ['dir'],
          big: [],
          blockquote: ['cite'],
          br: [],
          caption: [],
          center: [],
          cite: [],
          code: [],
          col: ['align', 'valign', 'span', 'width'],
          colgroup: ['align', 'valign', 'span', 'width'],
          dd: [],
          del: ['datetime'],
          details: ['open'],
          div: [],
          dl: [],
          dt: [],
          em: [],
          font: ['color', 'size', 'face'],
          footer: [],
          h1: [],
          h2: [],
          h3: [],
          h4: [],
          h5: [],
          h6: [],
          header: [],
          hr: [],
          i: [],
          img: ['src', 'alt', 'title', 'width', 'height'],
          ins: ['datetime'],
          li: [],
          mark: [],
          nav: [],
          ol: [],
          p: [],
          pre: [],
          s: [],
          section: [],
          small: [],
          span: [],
          sub: [],
          sup: [],
          strong: [],
          u: [],
          ul: [],
          p: ['style'],
          strong: ['style'],
          span: ['style'],
          br: [],
          img: ['style', 'src', 'border', 'width', 'height']
        },
        stripIgnoreTag: true, // 过滤所有非白名单标签的HTML
        stripIgnoreTagBody: ['script', 'iframe'] // script标签较特殊，需要过滤标签中间的内容
      });
      return html;
    },
    getUserInfo() {
      let s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/user/getUserInfo')
          .then(res => {
            if (res.data && res.data.status === 200) {
              this.getMsgCentreInfo();
              // this.$bus.$emit('send', res.data.data.unReadSiteMsgCount);
              store.commit('setUnReadBbsCount', res.data.data.unReadBbsCount)
              store.commit('setUnReadMsgListCount', res.data.data.unReadMsgListCount)
              store.commit('setUnReadSiteMsgCount', res.data.data.unReadSiteMsgCount)
              this.msgData.userName = res.data.data.displayName;
            } else {
              this.isNotLogin = true;
            }
          })
          .catch(error => {
            if (error.response && error.response.data && error.response.data.code === 'hihonor.account.00010010') {
              this.isEffect = true;
              this.isNotLogin = true;
            }
          });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.dialog-content {
  text-align: center;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
  font-size: 1rem;
  color: #606266;
}
.login-dialog {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  /deep/.xui-dialog__grayheader .xui-dialog__titleBox {
    text-align: center !important;
    .xui-dialog__graytitle {
      font-size: 1.2rem !important;
      font-weight: normal;
      padding-left: 0;
    }
  }
  /deep/.xui-dialog__body {
    padding: 0 2rem !important;
    font-size: 1rem !important;
    line-height: 2;
    text-align: center;
  }
  /deep/.xui-dialog__footer {
    text-align: center;
    padding: 2rem !important;
  }
  /deep/.xui-button.xui-button--primary {
    background: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff;
      border-color: #66b1ff;
    }
    span {
      color: #fff;
      font-size: 0.8rem !important;
      font-weight: normal;
    }
  }
}
/deep/.xui-table__empty-text {
  display: none;
}
/deep/ .xui-dialog__titleBox {
  background: #ffffff;
  border-bottom: 1px solid #ffffff;
}
.msg-title {
  margin: 1rem;
  font-weight: bold;
  font-size: 1rem;
}
.msg-html {
  margin: 1rem;
  max-height: 300px;
  overflow-y: scroll;
  word-break: break-all;
  line-height: 1.5rem;
  .addresseeName {
    font-weight: bold;
  }
}
.msg-time {
  margin: 1rem;
  text-align: right;
}

// 20220812界面改版需求新增
.user-center__msg-row{
  display:flex;
  align-items: center;
  padding: 20px 50px;
}

.user-center__msg-icon--default{
  font-size: var(--src--text-size-large-extra11);
  color: var(--src-color-primary-deep);
}

.user-center__msg-number{
  margin-left: 15px;
  font-size: var(--src--text-size-large-extra1);
  color: var(--src-color-primary-dark5);
  font-weight: var(--src-text-weight-light1);
}

.user-center__msg-number-txt{
  font-size: var(--src--text-size-large);
  color: var(--src-bg-color-blue-dark1);
  font-weight: var(--src-text-weight-dark1);
}

.user-center__msg-operation{
  display: flex;
  justify-content: flex-end;
  padding:20px 50px 15px;
}

.user-center__msg-operation-button{
  height: 30px;
  line-height: 28px;
  padding:0 19px;
  margin-left: 10px;
  border: 1px solid rgba(228,228,228,1);
  font-size: var(--src--text-size-small);
  color: var(--src-color-primary-dark6);
  font-weight:  var(--src-text-weight-light1);
  border-radius: 19px;
}

.user-center__msg-list{
  padding:0 50px;
  overflow:hidden;
}

/deep/.user-center__msg-list .xui-table{
  border-right:1px solid var(--src-color-secondary-light7);
  font-size: var(--src--text-size-default);
}

/deep/.user-center__msg-list .xui-table th .cell{
  color: var(--src-color-primary-dark6);
  font-weight: var(--src-text-weight-light1);
}

/deep/.user-center__msg-list .xui-table th .cell,
/deep/.user-center__msg-list .xui-table td .cell
{
  padding: 0 10px;
}

/deep/.user-center__msg-list .xui-table th,
/deep/.user-center__msg-list .xui-table td{
  border-left:1px solid var(--src-color-secondary-light7);
  border-top:1px solid var(--src-color-secondary-light7);
  border-bottom: none;
}

.user-center__msg-list-link{
  color: var(--src-bg-color-blue-dark1);
}

.user-center__msg-pager{
  padding: 20px 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/usercenter/sitemsg/UsercenterSiteMsg.vue